module.exports = __webpack_public_path__ + "static/media/005-astronomy.51c78b1b.svg";